import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { DocumentLoadInstrumentation } from '@opentelemetry/instrumentation-document-load';
import { resourceFromAttributes } from '@opentelemetry/resources';
import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION
} from '@opentelemetry/semantic-conventions';
import { AppConfig } from "./AppConfig";

export function initOpenTelemetry() {
  if (!AppConfig.otel.ENABLED) {
    return;
  }

  if (!AppConfig.otel.EXPORTER_OTLP_ENDPOINT) {
    console.warn("OpenTelemetry is enabled, but EXPORTER_OTLP_ENDPOINT is not configured.");
    return;
  }

  const exporter = new OTLPTraceExporter({
    url: AppConfig.otel.EXPORTER_OTLP_ENDPOINT,
    headers: AppConfig.otel.HEADERS || {}
  });

  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      [ATTR_SERVICE_NAME]: AppConfig.otel.SERVICE_NAME || 'crm-app',
      [ATTR_SERVICE_VERSION]: AppConfig.otel.SERVICE_VERSION || '0.1.0'
    }),
    spanProcessors: [
      new BatchSpanProcessor(exporter)
    ]
  });

  provider.register({
    contextManager: new ZoneContextManager()
  });

  registerInstrumentations({
    instrumentations: [
      new DocumentLoadInstrumentation(),
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: [/.*/]
      }),
      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: [/.*/]
      })
    ]
  });
}